import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import I18n from 'i18n-js';
import { Row, Icon } from 'grab-ui';
import cx from 'classnames';
import DivButton from 'components/v2/div-button/div-button';
import { getOrderStatusToRender } from 'helper/history-order';
import { getDeliveryID } from 'helper/order';
import { ongoingDeliveriesV2Selector } from 'selectors/new-history-selectors';
import { GE_ORDER_STATE } from 'constants/order-constants';
import ScribeDuck from 'ducks/scribe-duck';
import TrackGADuck from 'ducks/track-ga-duck';
import styles from './recent-update-section.less';
import commonStyles from './common.less';

const BookOrder = memo(({ order, onClick }) => {
  const isDroppingOff =
    order.status === GE_ORDER_STATE.DroppingOff ||
    order.status === GE_ORDER_STATE.PendingDropOff;
  const text = `${getOrderStatusToRender(order)} ∙ ${getDeliveryID(order)}`;
  const recipient = _get(order, 'steps[1].contact.name');

  return (
    <DivButton className={styles.recentUpdateItem} onClick={onClick}>
      <Row type="flex" className={styles.leftPanel}>
        <div
          className={cx(styles.icon, {
            [styles.iconDroppingOff]: isDroppingOff,
            [styles.iconPickingUp]: !isDroppingOff,
          })}
        >
          <img
            src={
              isDroppingOff
                ? require('public/images/upload.svg')
                : require('public/images/upload.svg')
            }
            alt=""
          />
        </div>
        <div className={styles.recipientInfo}>
          <h5>{`${I18n.t('v2.commonButton.to')} ${recipient}`}</h5>
          <h6>{text}</h6>
        </div>
      </Row>
      <Icon type="right" />
    </DivButton>
  );
});

BookOrder.propTypes = {
  order: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func.isRequired,
};

const RecentUpdateSection = ({ goToBookingsTab }) => {
  const dispatch = useDispatch();
  const { deliveries } = useSelector(ongoingDeliveriesV2Selector);
  const twoOrders = useMemo(() => deliveries.slice(0, 2), [deliveries]);

  const trackAnalytics = () => {
    dispatch(
      TrackGADuck.creators.trackGAExpressHomepageWebClick('VIEW_UPCOMING', {
        ONGOING_BOOKINGS: deliveries.length,
      }),
    );
    dispatch(ScribeDuck.creators.scribeExpressHomePageWebRecentOrder());
  };

  const trackAndNavigate = () => {
    trackAnalytics();
    goToBookingsTab();
  };

  return (
    <div className={styles.recentUpdateSection}>
      <div className={commonStyles.sectionHeader}>
        <h5 className={commonStyles.title}>
          {I18n.t('v2.homepage.orderOverview.latestUpdate')}
        </h5>
        <DivButton className={commonStyles.cta} onClick={trackAndNavigate}>
          {I18n.t('v2.homepage.orderOverview.viewAll')}
        </DivButton>
      </div>
      <div className={styles.recentUpdateContent}>
        {twoOrders.map(order => (
          <BookOrder
            key={getDeliveryID(order)}
            order={order}
            onClick={trackAndNavigate}
          />
        ))}
      </div>
    </div>
  );
};

RecentUpdateSection.propTypes = {
  goToBookingsTab: PropTypes.func.isRequired,
};

export default RecentUpdateSection;
